// src/app/shared/shared.module.ts
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MapComponent } from './components/map/map.component';
import { ScaleLineComponent } from './components/scale-line/scale-line.component';
import { MousePositionComponent } from './components/mouse-position/mouse-position.component';
import { FilterPipe } from './shared/pipes/filterByProperty';
import { CalendarComponent } from './shared/components/calendar/c.component';
import {TranslateModule} from "@ngx-translate/core";
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { CheckboxModule } from 'primeng/checkbox';
@NgModule({
    declarations: [
        MapComponent,
        ScaleLineComponent,
        MousePositionComponent,
        FilterPipe
    ],
    imports: [
      CommonModule,
      TranslateModule,
      ProgressSpinnerModule,
      CheckboxModule
    ],
    exports: [
        MapComponent,
        ScaleLineComponent,
        MousePositionComponent,
        FilterPipe,
        CheckboxModule,
        TranslateModule,
        ProgressSpinnerModule
    ]
})
export class SharedMobileModule { }



